import toastr from '@/lib/notifications'
import $ from 'jquery'
import _ from 'underscore'
import axios from 'axios'
import store from '../state/store'

store.on('enquiry:lesson_plans:index', function(enquiry_id) {
  $.ajax({
    url: `/api/sales/enquiries/${enquiry_id}/lesson_plans`,
    type: 'GET',
    dataType: 'json',
    contentType: 'application/json',
    success: (data) => {
      let first_lesson_plan
      store.get().enquiry.lesson_plans.reset(data.items)

      if (first_lesson_plan = _.first(data.items)) {
        store.get().ui.enquiry.set({lesson_plan_id: first_lesson_plan.id})
      }

      store.emit('ui:query_string:refresh')
    },
    error: (data) => {
      if (data && data.responseJSON && data.responseJSON.custom_error_message)
        toastr.error(data.responseJSON.custom_error_message)
      else
        toastr.error('something went wrong')
    }
  })
})

store.on('enquiry:lesson_plans:show', function(enquiry_id, lesson_plan_id) {
  const params =
    {lesson_plan_id}

  $.ajax({
    url: `/api/sales/enquiries/${enquiry_id}/lesson_plans/${lesson_plan_id}`,
    type: 'GET',
    dataType: 'json',
    contentType: 'application/json',
    data: params,
    success: (data) => {
      let lesson_plan
      if (lesson_plan = _.first(_.select(store.get().enquiry.lesson_plans, (lesson_plan) => {return lesson_plan.id === data.id}))) {
        lesson_plan.set(data)
        store.get().set({tutor_proposals: lesson_plan.tutoring_job.tutor_proposals})
      }
    },
    error: (data) => {
      if (data && data.responseJSON && data.responseJSON.custom_error_message)
        toastr.error(data.responseJSON.custom_error_message)
      else
        toastr.error('something went wrong')
    }
  })
})

store.on('enquiry:lesson_plans:create', function(enquiry_id, params) {
  if (params == null) { params = {} }
  const create_params = {
    enquiry_subject_ids: params.enquiry_subject_ids,
    enquiry_learner_ids: params.enquiry_learner_ids
  }

  $.ajax({
    url: `/api/sales/enquiries/${enquiry_id}/lesson_plans`,
    type: 'POST',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(create_params),
    success: (data) => {
      store.get().enquiry.lesson_plans.unshift(data)

      store.get().ui.enquiry.set({tab_key: `lp${store.get().enquiry.lesson_plans[0].id}`, lesson_plan_id: store.get().enquiry.lesson_plans[0].id})
      store.emit('ui:query_string:refresh')
    },
    error: (data) => {
      if (data && data.responseJSON && data.responseJSON.custom_error_message)
        toastr.error(data.responseJSON.custom_error_message)
      else
        toastr.error('something went wrong')
    }
  })
})

store.on('enquiry:lesson_plans:update', function(enquiry_id, lesson_plan_id, update_params = {}) {
  const request_params = _.extend(update_params, {lesson_plan_id})

  axios.put(`/api/sales/enquiries/${enquiry_id}/lesson_plans/${lesson_plan_id}`, request_params)
  .then((response) => {
    const data = response.data

    const lesson_plan = _.first(
      _.select(store.get().enquiry.lesson_plans, (lesson_plan) => {
        return lesson_plan.id === data.id
      })
    )

    lesson_plan.set(data)
    store.get().ui.enquiry.set({lesson_plan_id})

    const filterFields = ['medium', 'tutor_gender', 'tutor_tier', 'language_id']
    if (_.some(filterFields, (f) => f in update_params)) {
      store.emit('tutoring_job:tutor_results:index', lesson_plan.tutoring_job.id)
    }
  })
  .catch((error) => {
    handleError(error)
  })
})

store.on('enquiry:lesson_plans:destroy', function(enquiry_id, lesson_plan_id) {
  const params = {lesson_plan_id}

  $.ajax({
    url: `/api/sales/enquiries/${enquiry_id}/lesson_plans/${lesson_plan_id}`,
    type: 'DELETE',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(params),
    success: (data) => {
      store.emit('enquiry:lesson_plans:index', enquiry_id)
    },
    error: (data) => {
      if (data && data.responseJSON && data.responseJSON.custom_error_message)
        toastr.error(data.responseJSON.custom_error_message)
      else
        toastr.error('something went wrong')
    }
  })
})

store.on('enquiry:lesson_plans:create_learner', function(enquiry_id, lesson_plan_id, learner_id) {
  const params = {learner_id}

  $.ajax({
    url: `/api/sales/lesson_plans/${lesson_plan_id}/learners`,
    type: 'POST',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(params),
    success: (data) => {
      store.emit('enquiry:lesson_plans:show', enquiry_id, lesson_plan_id)
    },
    error: (data) => {
      if (data && data.responseJSON && data.responseJSON.custom_error_message)
        toastr.error(data.responseJSON.custom_error_message)
      else
        toastr.error('something went wrong')
    }
  })
})

store.on('enquiry:lesson_plans:destroy_learner', function(enquiry_id, lesson_plan_id, learner_id) {
  const params = {learner_id}

  $.ajax({
    url: `/api/sales/lesson_plans/${lesson_plan_id}/learners/${learner_id}`,
    type: 'DELETE',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(params),
    success: (data) => {
      store.emit('enquiry:lesson_plans:show', enquiry_id, lesson_plan_id)
    },
    error: (data) => {
      if (data && data.responseJSON && data.responseJSON.custom_error_message)
        toastr.error(data.responseJSON.custom_error_message)
      else
        toastr.error('something went wrong')
    }
  })
})

store.on('enquiry:lesson_plans:create_subject', function(enquiry_id, lesson_plan_id, subject_id) {
  const params = {subject_id}

  $.ajax({
    url: `/api/sales/lesson_plans/${lesson_plan_id}/subjects`,
    type: 'POST',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(params),
    success: (data) => {
      store.emit('enquiry:lesson_plans:show', enquiry_id, lesson_plan_id)
      store.emit('lesson_plan:tutor_results:index', lesson_plan_id)
    },
    error: (data) => {
      if (data && data.responseJSON && data.responseJSON.custom_error_message)
        toastr.error(data.responseJSON.custom_error_message)
      else
        toastr.error('something went wrong')
    }
  })
})

store.on('enquiry:lesson_plans:destroy_subject', function(enquiry_id, lesson_plan_id, subject_id) {
  const params = {subject_id}

  $.ajax({
    url: `/api/sales/lesson_plans/${lesson_plan_id}/subjects/${subject_id}`,
    type: 'DELETE',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(params),
    success: (data) => {
      store.emit('enquiry:lesson_plans:show', enquiry_id, lesson_plan_id)
      store.emit('lesson_plan:tutor_results:index', lesson_plan_id)
    },
    error: (data) => {
      if (data && data.responseJSON && data.responseJSON.custom_error_message)
        toastr.error(data.responseJSON.custom_error_message)
      else
        toastr.error('something went wrong')
    }
  })
})

store.on('enquiry:lesson_plans:availability:update', function(enquiry_id, lesson_plan_id, timeslots) {
  const params = {
    timeslots: timeslots
  }

  $.ajax({
    url: `/api/sales/lesson_plans/${lesson_plan_id}/availabilities`,
    type: 'POST',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(params),
    success: (data) => {
      toastr.success('Availability saved!')
      store.emit('enquiry:lesson_plans:show', enquiry_id, lesson_plan_id)
      store.emit('lesson_plan:tutor_results:index', lesson_plan_id)
    },
    error: (data) => {
      if (data && data.responseJSON && data.responseJSON.custom_error_message)
        toastr.error(data.responseJSON.custom_error_message)
      else
        toastr.error('something went wrong')
    }
  })
})
